import * as React from 'react';
import ReactDOM from "react-dom/client";
import { initalizeStore } from 'app/startup/store';
import { Provider } from 'react-redux';
import Main from 'app/shared/ui/Main'
import pageSystemReducer, { initializeRouting } from 'app/shared/pageSystem'
import {reducer as currentUser} from 'app/shared/currentUser';
import routes from 'app/routes';
import { MsalProvider } from "@azure/msal-react";
import 'antd/dist/reset.css';
import 'react-day-picker/style.css';
import 'core-js/stable';
import 'whatwg-fetch';
import MainWrapper from './shared/ui/MainWrapper';
import { msalInstance, msalInitPromise  } from 'app/auth/msalInstance';
import { BrowserRouter } from 'react-router-dom';
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);

const systemReducers = {
    currentPage: pageSystemReducer,
    currentUser: currentUser
}

const store = await initalizeStore(systemReducers);

initializeRouting(store, systemReducers, routes);

msalInitPromise.then(() => {
    const rootElement = document.getElementById("root");
    if(rootElement){
        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <React.StrictMode>
                <MsalProvider instance={msalInstance}>
                    <Provider store={store}>
                          <BrowserRouter>
                              <MainWrapper />
                          </BrowserRouter>
                    </Provider>
                </MsalProvider>
            </React.StrictMode>
        );
    }
}).catch(err => {
    console.error("Failed to initialize MSAL", err);
});
